import styled from 'styled-components';
import { Label, Container } from './Styles';

const XContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 22px;
  height: 22px;
  margin: 5px 0;
  cursor: pointer;
  border-radius: 22px;
  border: 2px solid var(--darkGrey);
  background: ${(props) => (!props.$isStared ? 'transparent' : '#fff')};

  svg {
    width: 14px;
    height: auto;
    path {
      fill: 'var(--darkGrey)';
    }
  }
`;

const XBtn = ({ clickEvent }) => (
  <Container onClick={() => clickEvent()}>
    <XContainer>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 640">
        <path
          d="M640,320,512,192,320,384,128,192,0,320,192,512,0,704,128,832,320,640,512,832,640,704,448,512Z"
          transform="translate(0 -192)"
        />
      </svg>
    </XContainer>
    <Label>Remove</Label>
  </Container>
);

export default XBtn;
